const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.000244141 5.00004C0.000244141 4.08004 0.746911 3.33337 1.66691 3.33337C2.58691 3.33337 3.33358 4.08004 3.33358 5.00004C3.33358 5.92004 2.58691 6.66671 1.66691 6.66671C0.746911 6.66671 0.000244141 5.92004 0.000244141 5.00004ZM0.000244141 10C0.000244141 9.08004 0.746911 8.33337 1.66691 8.33337C2.58691 8.33337 3.33358 9.08004 3.33358 10C3.33358 10.92 2.58691 11.6667 1.66691 11.6667C0.746911 11.6667 0.000244141 10.92 0.000244141 10ZM1.66691 13.3334C0.746911 13.3334 0.000244141 14.08 0.000244141 15C0.000244141 15.92 0.746911 16.6667 1.66691 16.6667C2.58691 16.6667 3.33358 15.92 3.33358 15C3.33358 14.08 2.58691 13.3334 1.66691 13.3334ZM19.1669 5.83337H5.83358C5.37441 5.83337 5.00024 5.45837 5.00024 5.00004C5.00024 4.54171 5.37441 4.16671 5.83358 4.16671H19.1669C19.6252 4.16671 20.0002 4.54171 20.0002 5.00004C20.0002 5.45837 19.6252 5.83337 19.1669 5.83337ZM19.1669 9.16671H5.83358C5.37441 9.16671 5.00024 9.54171 5.00024 10C5.00024 10.4584 5.37441 10.8334 5.83358 10.8334H19.1669C19.6252 10.8334 20.0002 10.4584 20.0002 10C20.0002 9.54171 19.6252 9.16671 19.1669 9.16671ZM5.83358 14.1667H19.1669C19.6252 14.1667 20.0002 14.5417 20.0002 15C20.0002 15.4584 19.6252 15.8334 19.1669 15.8334H5.83358C5.37441 15.8334 5.00024 15.4584 5.00024 15C5.00024 14.5417 5.37441 14.1667 5.83358 14.1667Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.000244141 5.00004C0.000244141 4.08004 0.746911 3.33337 1.66691 3.33337C2.58691 3.33337 3.33358 4.08004 3.33358 5.00004C3.33358 5.92004 2.58691 6.66671 1.66691 6.66671C0.746911 6.66671 0.000244141 5.92004 0.000244141 5.00004ZM0.000244141 10C0.000244141 9.08004 0.746911 8.33337 1.66691 8.33337C2.58691 8.33337 3.33358 9.08004 3.33358 10C3.33358 10.92 2.58691 11.6667 1.66691 11.6667C0.746911 11.6667 0.000244141 10.92 0.000244141 10ZM1.66691 13.3334C0.746911 13.3334 0.000244141 14.08 0.000244141 15C0.000244141 15.92 0.746911 16.6667 1.66691 16.6667C2.58691 16.6667 3.33358 15.92 3.33358 15C3.33358 14.08 2.58691 13.3334 1.66691 13.3334ZM19.1669 5.83337H5.83358C5.37441 5.83337 5.00024 5.45837 5.00024 5.00004C5.00024 4.54171 5.37441 4.16671 5.83358 4.16671H19.1669C19.6252 4.16671 20.0002 4.54171 20.0002 5.00004C20.0002 5.45837 19.6252 5.83337 19.1669 5.83337ZM19.1669 9.16671H5.83358C5.37441 9.16671 5.00024 9.54171 5.00024 10C5.00024 10.4584 5.37441 10.8334 5.83358 10.8334H19.1669C19.6252 10.8334 20.0002 10.4584 20.0002 10C20.0002 9.54171 19.6252 9.16671 19.1669 9.16671ZM5.83358 14.1667H19.1669C19.6252 14.1667 20.0002 14.5417 20.0002 15C20.0002 15.4584 19.6252 15.8334 19.1669 15.8334H5.83358C5.37441 15.8334 5.00024 15.4584 5.00024 15C5.00024 14.5417 5.37441 14.1667 5.83358 14.1667Z"
});

const SvgUnorderedList = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2994_21927",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 21,
    height: 14
  }, _ref3));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnorderedList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unordered-list.5cd8ca3b.svg";
export { ForwardRef as ReactComponent };